<template>
  <div class="switch" :class="{
    'switch--reverse': props.isReverseSigns
  }">
    <label
      class="switch__box"
      :class="{
        'switch__box--disabled': props.isDisabled
      }"
    >
      <input
        @click="OnClick"
        type="checkbox"
        :checked="localState"
        :disabled="props.isDisabled"
      />
      <div class="switch__round"></div>
    </label>
    <div class="switch__signs" v-if="isLeft" :class="{
    'switch__signs--reverse': props.isReverseSigns
  }">
      <span class="switch__main-sign">
        <slot name="mainSign"></slot>
      </span>
      <span class="switch__hint-sign">
        <slot name="hintSign"></slot>
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineEmits, defineProps, ref, useSlots, watch } from 'vue'
const slots = useSlots()

/**
 * Есть ли слот для лейбла
 */
const isLeft = computed(() => slots && slots.mainSign && slots.mainSign())

const emit = defineEmits<{
  (eventName: 'update:modelValue', value: boolean): void
}>()

const props = defineProps<{
  /** Состояние кнопки */
  modelValue?: boolean
  /** Блокировка */
  isDisabled?: boolean
  /** Лейбл слева */
  isReverseSigns?: boolean
}>()

let localState = ref(props.modelValue)

watch(() => props.modelValue, () => {
  localState.value = !!props.modelValue;
});

/** Состояние кнопки */

/** Обработка клика на кнопку */
const OnClick = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
